export default __webpack_public_path__ + "static/media/creditoja-blog2.7b35ee7b.jpg";